import type { ArticleType, ArticleTag } from 'types';

export function getUniqueArticleTags(articles: ArticleType[]): ArticleTag[] {
  const tagMap = new Map<string, ArticleTag>();

  articles.forEach((article) => {
    article.tags?.forEach((tag) => {
      tagMap.set(tag.slug, tag);
    });
  });

  return Array.from(tagMap.values()).sort((a, b) =>
    a.name.localeCompare(b.name)
  );
}

export function filterArticlesByTag(
  articles: ArticleType[],
  tagSlug?: string
): ArticleType[] {
  if (!tagSlug) {
    return articles;
  }

  return articles.filter((article) =>
    article.tags?.some((tag) => tag.slug === tagSlug)
  );
}
